import axios from "axios";
import Config from "../../config/index";
import {
  ACCEPTED_BY_SUID_FAILURE,
  ACCEPTED_BY_SUID_REQUEST,
  ACCEPTED_BY_SUID_SUCCESS,
  CREATE_PICKLIST_FOR_1_FLOW_FAILURE,
  CREATE_PICKLIST_FOR_1_FLOW_REQUEST,
  CREATE_PICKLIST_FOR_1_FLOW_SUCCESS,
  CREATE_PICKLIST_FOR_3_FLOW_FAILURE,
  CREATE_PICKLIST_FOR_3_FLOW_REQUEST,
  CREATE_PICKLIST_FOR_3_FLOW_SUCCESS,
  CREATE_REJECTION_FAILURE,
  CREATE_REJECTION_REQUEST,
  CREATE_REJECTION_SUCCESS,
  GET_ACCEPTED_REJECTIONS_FAILURE,
  GET_ACCEPTED_REJECTIONS_REQUEST,
  GET_ACCEPTED_REJECTIONS_SUCCESS,
  GET_REJECTIONS_FAILURE,
  GET_REJECTIONS_REQUEST,
  GET_REJECTIONS_SUCCESS,
  GET_SKU_BYDOCUMENTNO_FOR_REJECTIONS_FAILURE,
  GET_SKU_BYDOCUMENTNO_FOR_REJECTIONS_REQUEST,
  GET_SKU_BYDOCUMENTNO_FOR_REJECTIONS_SUCCESS,
  PUT_RELEASE_REJECTIONS_FAILURE,
  PUT_RELEASE_REJECTIONS_REQUEST,
  PUT_RELEASE_REJECTIONS_SUCCESS,
  REJECTIONS_2_FLOW_FAILURE,
  REJECTIONS_2_FLOW_REQUEST,
  REJECTIONS_2_FLOW_SUCCESS,
  REJECTIONS_BY_SUID_FAILURE,
  REJECTIONS_BY_SUID_REQUEST,
  REJECTIONS_BY_SUID_SUCCESS,
  REJECTIONS_FOR_3_FLOW_FAILURE,
  REJECTIONS_FOR_3_FLOW_REQUEST,
  REJECTIONS_FOR_3_FLOW_SUCCESS,
  REJECTIONS_RELEASE_1_FLOW_FAILURE,
  REJECTIONS_RELEASE_1_FLOW_REQUEST,
  REJECTIONS_RELEASE_1_FLOW_SUCCESS,
} from "./rejectionTypes";
let baseUrl = Config.baseUrl;

const getRejectionsRequest = () => {
  return {
    type: GET_REJECTIONS_REQUEST,
  };
};

const getRejectionsSuccess = (payload) => {
  return {
    type: GET_REJECTIONS_SUCCESS,
    payload: payload,
  };
};

const getRejectionsFailure = (error) => {
  return {
    type: GET_REJECTIONS_FAILURE,
    payload: error,
  };
};

const getRejections = (pageNo, rowsPerPage, search, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getRejectionsRequest());
    let url = `${baseUrl}/rejection/get_rejection_pending_suids?page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getRejectionsSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getRejectionsFailure(err.message));
      });
  };
};

const getAcceptedRejectionsRequest = () => {
  return {
    type: GET_ACCEPTED_REJECTIONS_REQUEST,
  };
};

const getAcceptedRejectionsSuccess = (payload) => {
  return {
    type: GET_ACCEPTED_REJECTIONS_SUCCESS,
    payload: payload,
  };
};

const getAcceptedRejectionsFaliure = (error) => {
  return {
    type: GET_ACCEPTED_REJECTIONS_FAILURE,
    payload: error,
  };
};

const getAcceptedRejections = (pageNo, rowsPerPage, search, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getAcceptedRejectionsRequest());
    let url = `${baseUrl}/rejection/common/get_rejected_suids_grouped?page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getAcceptedRejectionsSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getAcceptedRejectionsFaliure(err.message));
      });
  };
};

const rejectionsRequesBySuid = () => {
  return {
    type: REJECTIONS_BY_SUID_REQUEST,
  };
};

const rejectionsSuccesBySuid = (payload) => {
  return {
    type: REJECTIONS_BY_SUID_SUCCESS,
    payload: payload,
  };
};

const rejectionsFailurBySuid = (error) => {
  return {
    type: REJECTIONS_BY_SUID_FAILURE,
    payload: error,
  };
};

const rejectionBySuid = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(rejectionsRequesBySuid());
    let url = `${baseUrl}/rejection/reject`;
    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(rejectionsSuccesBySuid(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(rejectionsFailurBySuid(err.response));
        return { status: false, data: err.response };
      });
  };
};

const releaseRejectionsRequest = () => {
  return {
    type: PUT_RELEASE_REJECTIONS_REQUEST,
  };
};

const releaseRejectionsSuccess = (payload) => {
  return {
    type: PUT_RELEASE_REJECTIONS_SUCCESS,
    payload: payload,
  };
};

const releaseRejectionsFailure = (error) => {
  return {
    type: PUT_RELEASE_REJECTIONS_FAILURE,
    payload: error,
  };
};

const releaseRejections = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(releaseRejectionsRequest());
    let url = `${baseUrl}/rejection/picklist`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(releaseRejectionsSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(releaseRejectionsFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const releaseForRejectionRequest = () => {
  return {
    type: REJECTIONS_RELEASE_1_FLOW_REQUEST,
  };
};

const releaseForRejectionSuccess = (payload) => {
  return {
    type: REJECTIONS_RELEASE_1_FLOW_SUCCESS,
    payload: payload,
  };
};

const releaseForRejectionFailure = (error) => {
  return {
    type: REJECTIONS_RELEASE_1_FLOW_FAILURE,
    payload: error,
  };
};

const releaseForRejection = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(releaseForRejectionRequest());
    let url = `${baseUrl}/rejection/common/release`;
    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(releaseForRejectionSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(releaseForRejectionFailure(err.message));
        return { status: false, data: err.message };
      });
  };
};

const createPicklistFor3FlowRequest = () => {
  return {
    type: CREATE_PICKLIST_FOR_3_FLOW_REQUEST,
  };
};

const createPicklistFor3FlowSuccess = (payload) => {
  return {
    type: CREATE_PICKLIST_FOR_3_FLOW_SUCCESS,
    payload: payload,
  };
};

const createPicklistFor3FlowFailure = (error) => {
  return {
    type: CREATE_PICKLIST_FOR_3_FLOW_FAILURE,
    payload: error,
  };
};

const createPicklistFor3Flow = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(createPicklistFor3FlowRequest());
    let url = `${baseUrl}/rejection_4/picklist`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(createPicklistFor3FlowSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createPicklistFor3FlowFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};
const createPicklistFor1FlowRequest = () => {
  return {
    type: CREATE_PICKLIST_FOR_1_FLOW_REQUEST,
  };
};

const createPicklistFor1FlowSuccess = (payload) => {
  return {
    type: CREATE_PICKLIST_FOR_1_FLOW_SUCCESS,
    payload: payload,
  };
};

const createPicklistFor1FlowFailure = (error) => {
  return {
    type: CREATE_PICKLIST_FOR_1_FLOW_FAILURE,
    payload: error,
  };
};

const createPicklistFor1Flow = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(createPicklistFor1FlowRequest());
    let url = `${baseUrl}/rejection_2/picklist`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(createPicklistFor1FlowSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createPicklistFor1FlowFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};
const rejectionsFor2flowRequest = () => {
  return {
    type: REJECTIONS_2_FLOW_REQUEST,
  };
};

const rejectionsFor2flowSuccess = (payload) => {
  return {
    type: REJECTIONS_2_FLOW_SUCCESS,
    payload: payload,
  };
};

const rejectionsFor2flowFailure = (error) => {
  return {
    type: REJECTIONS_2_FLOW_FAILURE,
    payload: error,
  };
};

const rejectionsFor2flow = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(rejectionsFor2flowRequest());
    let url = `${baseUrl}/rejection/direct_reject_with_picklist`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(rejectionsFor2flowSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(rejectionsFor2flowFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const acceptedBySuidRequesBySuid = () => {
  return {
    type: ACCEPTED_BY_SUID_REQUEST,
  };
};

const acceptedBySuidSuccesBySuid = (payload) => {
  return {
    type: ACCEPTED_BY_SUID_SUCCESS,
    payload: payload,
  };
};

const acceptedBySuidFailurBySuid = (error) => {
  return {
    type: ACCEPTED_BY_SUID_FAILURE,
    payload: error,
  };
};

const acceptedBySuid = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(acceptedBySuidRequesBySuid());
    let url = `${baseUrl}/rejection/accept`;
    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(acceptedBySuidSuccesBySuid(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(acceptedBySuidFailurBySuid(err.response));
        return { status: false, data: err.response };
      });
  };
};
const createRejectionsForAcceptedListRequest = () => {
  return {
    type: CREATE_REJECTION_REQUEST,
  };
};

const createRejectionsForAcceptedListSuccess = (payload) => {
  return {
    type: CREATE_REJECTION_SUCCESS,
    payload: payload,
  };
};

const createRejectionsForAcceptedListFailure = (error) => {
  return {
    type: CREATE_REJECTION_FAILURE,
    payload: error,
  };
};

const createRejectionsForAcceptedList = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(createRejectionsForAcceptedListRequest());
    let url = `${baseUrl}/rejection/common/direct_reject`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(createRejectionsForAcceptedListSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createRejectionsForAcceptedListFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};
const createRejectionsFor3FlowRequest = () => {
  return {
    type: REJECTIONS_FOR_3_FLOW_REQUEST,
  };
};

const createRejectionsFor3FlowSuccess = (payload) => {
  return {
    type: REJECTIONS_FOR_3_FLOW_SUCCESS,
    payload: payload,
  };
};

const createRejectionsFor3FlowFailure = (error) => {
  return {
    type: REJECTIONS_FOR_3_FLOW_FAILURE,
    payload: error,
  };
};

const createRejectionsFor3Flow = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(createRejectionsFor3FlowRequest());
    let url = `${baseUrl}/rejection_4/direct_reject_with_picklist`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(createRejectionsFor3FlowSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createRejectionsFor3FlowFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const getSkuByDocumentNoForRejectionsRequest = () => {
  return {
    type: GET_SKU_BYDOCUMENTNO_FOR_REJECTIONS_REQUEST,
  };
};

const getSkuByDocumentNoForRejectionsSuccess = (payload) => {
  return {
    type: GET_SKU_BYDOCUMENTNO_FOR_REJECTIONS_SUCCESS,
    payload: payload,
  };
};

const getSkuByDocumentNoForRejectionsFailure = (error) => {
  return {
    type: GET_SKU_BYDOCUMENTNO_FOR_REJECTIONS_FAILURE,
    payload: error,
  };
};

const getSkuByDocumentNoForRejections = (documentTrId, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getSkuByDocumentNoForRejectionsRequest());
    let url = `${baseUrl}/rejection/common/get_suids_by_doc_no?doc_id=${documentTrId}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getSkuByDocumentNoForRejectionsSuccess(response.data.data));
      })
      .catch((err) => {
        dispatch(getSkuByDocumentNoForRejectionsFailure(err.message));
      });
  };
};

export {
  acceptedBySuid,
  createPicklistFor1Flow,
  createPicklistFor3Flow,
  createRejectionsFor3Flow,
  createRejectionsForAcceptedList,
  getAcceptedRejections,
  getRejections,
  getSkuByDocumentNoForRejections,
  rejectionBySuid,
  rejectionsFor2flow,
  releaseForRejection,
  releaseRejections,
};
